module.exports = __webpack_public_path__ + "static/media/showroom.e5a539a7.png";